import React from 'react';
import './MyAccountBalance.style.scss';
import {useSelector} from "react-redux";
import {selectUserAccount} from "../../stores/account/account.selectors";
import {FormattedMessage} from "react-intl";
import SecureDepositPopUp from "../../views/PopUps/SecureDepositPopUp/SecureDepositPopUp";
import useAppModalService from "../../hooks/useAppModalService";
import GlobalConst from "../../constants/GlobalConst";
import {ModalType} from "../AppModal/ModalTypes";
import Currency from "../Currency/Currency";

const MyAccountBalance = ({onSideMenu}) => {
    const {openModal, closeModal, modalStack, stackSize} = useAppModalService();
    const userAccount = useSelector(selectUserAccount);

    if(!userAccount)
        return null;

    const handleDepositClick = async () => {
        if (GlobalConst.FEATURES.ADD_FUNDS)
            await openModal('deposit', ModalType.CUSTOM, {
                title: 'Secure Deposit',
                modalComponent: SecureDepositPopUp,
            });
    };

    return (
        <div className={"MyAccountBalance" + (onSideMenu ? " onSideMenu" : "")}>
            <div className="accountBalanceTitle">
                <FormattedMessage id={"myAccountView.myProfile.accountBalanceTitle"}/>
            </div>
            <div className="accountBalanceItem">
                <span><FormattedMessage id={"myAccountView.myProfile.cash"}/> (<FormattedMessage id={"myAccountView.myProfile.availableForWithdrawal"}/>)</span>
                <span className="accountBalanceValue">
                    { GlobalConst.SITE_TLD === ".com" && <Currency value={userAccount.availableCash} currency={"US"} />}
                    { GlobalConst.SITE_TLD === ".fr" && <Currency value={userAccount.availableEuro} currency={"EURO"} />}
                    { GlobalConst.SITE_TLD === ".mx" && <Currency value={userAccount.availableMXN} currency={"MXN"} />}
                </span>
            </div>
            <div className="accountBalanceItem">
                <span>
                    <FormattedMessage id={"myAccountView.myProfile.tradeFanDollars"}/>
                </span>
                <span className="account-balance-value">
                    { GlobalConst.SITE_TLD === ".com" && <Currency value={userAccount.availableTFCash} currency={"US"} />}
                    { GlobalConst.SITE_TLD === ".fr" && <Currency value={userAccount.availableTFCash} currency={"EURO"} />}
                    { GlobalConst.SITE_TLD === ".mx" && <Currency value={userAccount.availableTFMXN} currency={"MXN"} />}
                </span>
            </div>
            {/*<div className="accountBalanceItem">
                <span>1 x <FormattedMessage id={"myAccountView.myProfile.ticket"} /></span>
                <span className="accountBalanceValue">$0</span>
            </div>*/}
            <div className="accountBalanceItem total">
                <span>
                    <FormattedMessage id={"myAccountView.myProfile.total"} />
                </span>
                <span className="accountBalanceValue">
                    { GlobalConst.SITE_TLD === ".com" && <Currency value={userAccount.availableUSDBalance} currency={"US"} />}
                    { GlobalConst.SITE_TLD === ".fr" && <Currency value={userAccount.availableEuroBalance} currency={"EURO"} />}
                    { GlobalConst.SITE_TLD === ".mx" && <Currency value={userAccount.availableMXNBalance} currency={"MXN"} />}
                </span>
            </div>
            {onSideMenu && <button className="depositButton"
                                   onClick={handleDepositClick}><FormattedMessage id={"myAccountView.myProfile.deposit"}/> </button>}
        </div>
    );
};

export default MyAccountBalance;
